var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.destinations),function(country,i){return _c('GlobalSearchDestination',{key:i,attrs:{"country":country},on:{"clicked-element":function($event){return _vm.$emit('clicked-element', $event)}}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }